import LogoMarkel from 'shared/lib/assets/img/logo/logo-markel.svg';

export const fineArtConfig = {
  hero: {
    heading: 'A Fine Idea: Coverage for your artwork',
    subheading:
      'The masterpieces within your home are worthy of extra protection. Here’s how to make sure they’re covered.',
    cta: 'Get fine art insurance',
    ctaLink: '/collectibles/fine-art/start',
    img: `${process.env.PUBLIC_URL}/images/collectibles/hero-fine-art.svg`,
  },
  underwriter: {
    img: LogoMarkel,
    name: 'Markel',
  },
  coverageDetails: [
    {
      heading: 'Theft',
      subheading:
        'You’re not the only one who appreciates priceless art—so you’re covered in the event of a theft.',
    },
    {
      heading: 'Coverage Beyond the Basics',
      subheading:
        'Homeowners insurance is great—but chances are it won’t fully cover your artwork. A specialized policy guarantees coverage at the right rates.',
    },
    {
      heading: 'Damages',
      subheading:
        'Damage to your artwork can be devastating—but you can rest easy knowing that repairs or replacements are covered.',
    },
    {
      heading: 'Insurance En Route',
      subheading:
        "This policy covers you from the moment of purchase, whether you're shipping an item to your home or transporting it yourself.",
    },
  ],
  scenarioDetails: {
    heading: 'Why Would You Need Fine Art Insurance?',
    scenarios: [
      {
        heading: 'Scenario 1',
        subheading: 'A poorly hung piece falls and sustains a tear.',
      },
      {
        heading: 'Scenario 2',
        subheading:
          'A savvy thief skips right past your piggy bank and makes off with your prized piece of art.',
      },
      {
        heading: 'Scenario 3',
        subheading:
          'A one-of-a-kind piece is damaged being delivered to your home.',
      },
      {
        heading: 'Scenario 4',
        subheading: 'A fire badly damages items in your collection.',
      },
    ],
  },
  comparison: [
    'Instant quote',
    'Buy and manage your policy in one place',
    'Insurance explained in simple, easy-to-digest way',
    'Mobile',
    'Endorsements',
    'Plan tailored to fit your needs',
  ],
};
